import React from 'react';
import RQLFeedItem from './rql_feed_item';
import { MixedFeedRow } from '../schemas/rql';
import gql from 'graphql-tag';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import { ListingsCollection } from '@reverbdotcom/commons/src/components/listings_collection';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

interface IProps {
  expectedCount: number;
  entries: MixedFeedRow.Fragment[];
  loading: boolean;
  cta?: JSX.Element;
  title?: string;
  singleRow?: boolean;
}

export const mixedFeedFragment = gql`
  fragment MixedFeedRow on reverb_feed_FeedEntry {
    id
    type
    deleted
    metadata {
      sourceType
    }
    localizedContents {
      locale
      title
      shortDescription
    }
    entry {
      ... on Article {
        _id
        id
        title
        images(
          input: {
            count: 1
            scope: "full_bleed_image"
            transform: "card_square"
          }
        ) {
          source
        }
        webLink {
          href
        }
        articleCategories {
          name
          slug
        }
      }
      ... on Listing {
        _id
        ...ListingsCollection
      }
    }
  }

  ${ListingsCollection.fragments.listing}
`;

export default function FeedRow(props: IProps) {
  return (
    <OverflowingRow
      collectionCount={props.entries.length}
      action={props.cta}
      title={props.title}
    >
      <Tiles
        placeholder={<RQLFeedItem />}
        loading={props.loading}
        expectedCount={props.expectedCount}
        largeTiles
        singleRow={props.singleRow}
      >
        {props.entries.map((entry, idx) => (
          <RQLFeedItem
            key={`${entry.__typename}-${entry.id}-${idx}`}
            entry={entry}
            position={idx}
          />
        ))}
      </Tiles>
    </OverflowingRow>
  );
}
